/**
 * XdcHealthMetrics Component
 *
 * Health metrics panel for XDC Network.
 */

import { Icons } from '../Icons';
import { GenericHealthMetrics, networkConfigs } from '../common/GenericHealthMetrics';
import type { XdcNetworkMetrics } from '../../services/blockchainHealthApi';

const XDC_COLOR = '#1D6FA3';

function renderXdcMetrics(metrics: Record<string, any>) {
  const m = (metrics || {}) as XdcNetworkMetrics;
  return (
    <>
      {/* Active Masternodes */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Server size={24} style={{ color: XDC_COLOR, marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: XDC_COLOR }}>
          {m.activeMasternodes ?? 0}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Masternodes
        </div>
      </div>

      {/* Block Height */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Hash size={24} style={{ color: '#2196F3', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#2196F3' }}>
          {m.blockHeight ?? '0'}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Block Height
        </div>
      </div>

      {/* TPS */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Zap size={24} style={{ color: '#f59e0b', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#f59e0b' }}>
          {(m.tps ?? 0).toLocaleString()}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Max TPS
        </div>
      </div>

      {/* Block Time */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Clock size={24} style={{ color: '#06b6d4', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#06b6d4' }}>
          {m.avgBlockTime ?? 0}s
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Block Time
        </div>
      </div>

      {/* Staking APY */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.TrendingUp size={24} style={{ color: '#22c55e', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#22c55e' }}>
          ~{m.stakingAPY ?? 0}%
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Masternode APY
        </div>
      </div>
    </>
  );
}

export function XdcHealthMetrics() {
  const config = {
    ...networkConfigs.xdc,
    renderNetworkMetrics: renderXdcMetrics,
  };

  return <GenericHealthMetrics config={config} />;
}
